import React, { useState } from "react";
import { Spin } from "antd";

import SbIncomeGraph from "../card/sbIncomeGraph";

const IncomeSmartbilling = () => {
  const [loading, setLoading] = useState(false);

  return (
    <div className="p-6">
      <h2 className="text-xl font-semibold text-[#32B7C2] mb-4">
        💰 Орлогын тойм
      </h2>
      <Spin spinning={loading}>
        <div className="grid gap-6">
          <SbIncomeGraph />
        </div>
      </Spin>
    </div>
  );
};

export default IncomeSmartbilling;
